import TuneOutlined from "@mui/icons-material/TuneOutlined";
import { Tooltip } from "@mui/material";

/**
 * The mark for settings that differ from the default: on an organization in the
 * list, on a section header, and inside a row's Overridden chip, so the one glyph
 * means the same thing everywhere. Announced as "Overridden"; the tooltip says where.
 */
export function OverridesMarker({ title }: { title: string }) {
  return (
    <Tooltip describeChild title={title}>
      <TuneOutlined
        fontSize="small"
        color="action"
        titleAccess="Overridden"
        sx={{ flexShrink: 0 }}
      />
    </Tooltip>
  );
}
